import Api from "../../lib/api";
import { setMessage } from "../shared/notification/slice";

export const fetchTripCoordinates = async (tripId) => {
    try {
        const response = await Api.get(`trips/${tripId}/coordinates`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};

export const fetchTripSnapToRoadCoordinates = async (tripId) => {
    try {
        const response = await Api.get(`trips/${tripId}/snap_to_roads_coordinates`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};

export const fetchTripPoints = async (tripId) => {
    try {
        const response = await Api.get(
            `trip-logs?filter[tripId]=${tripId}&page[size]=100&sort=loggedAt&filter[logType]=trip_point,waiting_point,error`
        );
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};

export const fetchTripLocations = async (tripId, isLive) => {
    let url = `trips/${tripId}/trip-locations`;
    if (isLive) {
        url += "?point_type=live";
    }
    try {
        const response = await Api.get(url);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve the trip`,
            isError: true,
        });
        return null;
    }
};
